
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisLocatingdeviceLostIec as ObiAisLocatingdeviceLostIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-locatingdevice-lost-iec.js';
 
 
 

 
 export const ObiAisLocatingdeviceLostIec = createComponent({
   react: React,
   tagName: 'obi-ais-locatingdevice-lost-iec',
   elementClass: ObiAisLocatingdeviceLostIecElement,
   events: {
     
   }
  });
 
 